
export class DatabaseDataType {
    id: number;
    name: string;

}